var _defs, _metadata;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsDc: "http://purl.org/dc/elements/1.1/",
    xmlnsCc: "http://creativecommons.org/ns#",
    xmlnsRdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    xmlns: "http://www.w3.org/2000/svg",
    width: "100.1888mm",
    height: "49.101501mm",
    viewBox: "0 0 100.1888 49.101501",
    id: "svg1528",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1522"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath885"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 1920 V 1080 H 0 Z",
    id: "path883"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath929"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 1920 V 1080 H 0 Z",
    id: "path927"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath953"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 1920 V 1080 H 0 Z",
    id: "path951"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath973"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 1920 V 1080 H 0 Z",
    id: "path971"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath989"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 1920 V 1080 H 0 Z",
    id: "path987"
  })))), _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata1525"
  }, /*#__PURE__*/React.createElement("rdfRDF", null, /*#__PURE__*/React.createElement("ccWork", {
    rdfAbout: ""
  }, /*#__PURE__*/React.createElement("dcFormat", null, "image/svg+xml"), /*#__PURE__*/React.createElement("dcType", {
    rdfResource: "http://purl.org/dc/dcmitype/StillImage"
  }), /*#__PURE__*/React.createElement("dcTitle", null))))), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-45.911552,-132.68734)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2331",
    transform: "matrix(0.35277777,0,0,-0.35277777,-317.4496,282.64314)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1378"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g879"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g881",
    clipPath: "url(#clipPath885)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g887",
    transform: "translate(1030.6033,353.364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -0.727,3.309 -0.859,6.613 -0.051,9.937 2.297,9.442 11.182,15.88 20.888,15.047 0.958,-0.082 1.328,0.176 1.584,1.081 0.625,2.223 1.348,4.419 2.075,6.612 0.201,0.606 0.116,1.003 -0.364,1.45 -2.069,1.926 -4.117,3.875 -6.133,5.857 -0.533,0.525 -1.014,0.621 -1.648,0.279 -0.333,-0.18 -0.691,-0.316 -1.048,-0.444 -1.736,-0.621 -3.603,0.127 -4.27,1.704 -0.668,1.58 0.07,3.455 1.744,4.25 1.307,0.621 2.656,1.155 3.988,1.725 2.664,1.139 5.322,2.292 7.995,3.407 1.315,0.548 2.577,0.422 3.664,-0.566 0.962,-0.876 1.207,-1.981 0.876,-3.212 -0.279,-1.035 -0.987,-1.722 -1.941,-2.155 -0.91,-0.414 -1.829,-0.811 -2.757,-1.183 -0.604,-0.241 -0.774,-0.515 -0.239,-1.017 1.232,-1.156 2.466,-2.31 3.668,-3.497 0.6,-0.592 1.026,-0.238 1.513,0.141 4.767,3.694 9.541,7.38 14.311,11.07 1.991,1.539 3.955,3.113 5.978,4.607 0.755,0.557 0.71,0.91 0.053,1.487 -0.93,0.819 -1.804,1.705 -2.669,2.594 -1.429,1.468 -1.37,3.452 0.165,4.836 2.535,2.285 5.084,4.554 7.65,6.803 1.451,1.271 3.42,1.168 4.627,-0.184 1.208,-1.353 1.072,-3.292 -0.37,-4.613 -1.449,-1.327 -2.916,-2.635 -4.412,-3.909 -0.576,-0.491 -0.65,-0.818 -0.063,-1.384 4.393,-4.234 8.764,-8.493 13.123,-12.764 0.489,-0.478 0.825,-0.49 1.407,-0.106 9.699,6.399 22.571,3.332 28.336,-6.726 5.362,-9.356 1.971,-21.593 -7.469,-26.955 -9.477,-5.382 -21.536,-2.223 -26.918,7.16 -3.906,6.812 -3.685,13.684 0.22,20.441 0.467,0.807 0.371,1.215 -0.269,1.807 -1.694,1.569 -3.319,3.212 -4.978,4.82 -0.212,0.206 -0.391,0.588 -0.73,0.474 C 57.21,48.765 57.257,48.351 57.19,48.059 54.802,37.709 52.4,27.362 50.057,17.003 49.676,15.319 48.779,14.266 47.208,13.63 44.811,12.659 42.446,11.609 40.068,10.591 38.554,9.943 38.554,9.943 38.81,8.356 40.23,-0.44 35.407,-9.365 27.322,-12.902 18.308,-16.847 7.96,-13.767 2.54,-5.529 2.409,-5.329 2.257,-5.141 2.115,-4.948 1.41,-3.299 0.705,-1.649 0,0 m 85.66,19.083 c 0.526,0.257 1.077,0.474 1.575,0.777 4.767,2.903 7.331,8.496 6.343,13.795 -1.055,5.659 -5.25,9.898 -10.898,10.912 -3.009,0.539 -5.896,0.108 -8.6,-1.388 -0.6,-0.332 -0.604,-0.637 -0.125,-1.082 0.807,-0.752 1.589,-1.529 2.38,-2.298 2.051,-1.994 4.119,-3.971 6.145,-5.991 1.715,-1.711 1.356,-4.256 -0.7,-5.296 -1.301,-0.657 -2.682,-0.373 -3.945,0.85 -2.722,2.638 -5.431,5.29 -8.148,7.934 -0.843,0.819 -0.951,0.798 -1.433,-0.23 -2.375,-5.077 -1.38,-11.017 2.522,-15.049 3.826,-3.955 9.749,-5.117 14.884,-2.934 M 24.447,-7.068 C 29.732,-4.796 33.02,0.526 32.59,6.112 32.503,7.241 32.404,7.309 31.339,6.857 28.105,5.481 24.875,4.095 21.642,2.714 21.326,2.578 21.013,2.43 20.687,2.318 19.362,1.863 18.1,1.9 17.02,2.912 15.933,3.931 15.826,5.18 16.25,6.53 c 1.178,3.747 2.337,7.5 3.553,11.235 0.239,0.732 0.08,0.903 -0.639,0.882 -1.882,-0.054 -3.718,-0.369 -5.42,-1.161 C 6.21,13.978 3.841,5.154 7.567,-1.359 10.948,-7.268 18.17,-9.766 24.447,-7.068 M 50.385,47.249 C 50.114,47.117 50.015,47.089 49.94,47.031 44.623,42.925 39.311,38.812 33.986,34.716 33.428,34.287 33.55,34.008 33.993,33.59 c 3.377,-3.202 6.745,-6.413 10.095,-9.643 0.647,-0.624 0.852,-0.539 1.044,0.335 0.846,3.839 1.751,7.664 2.629,11.495 0.863,3.758 1.72,7.518 2.624,11.472 M 24.448,11.084 c 0.305,0.062 0.41,0.066 0.5,0.105 5.037,2.149 10.069,4.309 15.112,6.444 0.791,0.335 0.706,0.631 0.16,1.147 -3.178,3.003 -6.347,6.016 -9.488,9.057 -0.609,0.589 -0.861,0.61 -1.123,-0.257 -0.774,-2.571 -1.608,-5.125 -2.411,-7.688 -0.906,-2.886 -1.803,-5.774 -2.75,-8.808",
    style: {
      fill: "#ffde00",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path889"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g891",
    transform: "translate(1149.5162,371.6573)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0,-5.041 2.967,-7.561 8.9,-7.561 7.125,0.019 11.385,3.632 12.787,10.845 l 1.365,6.931 H 15.621 L 14.256,3.284 C 13.801,0.955 12.488,-0.21 10.318,-0.21 8.165,-0.21 7.316,0.955 7.772,3.284 l 2.363,12.077 H 24.049 L 27.83,34.79 c 0.227,1.188 0.341,2.272 0.341,3.255 0,5.041 -2.976,7.561 -8.926,7.561 -7.106,0 -11.359,-3.609 -12.76,-10.816 L 0.342,3.284 C 0.115,2.091 0,0.998 0,0 m 13.915,34.79 c 0.437,2.324 1.723,3.489 3.86,3.489 h 0.052 C 19.98,38.265 20.836,37.1 20.4,34.79 L 18.037,22.712 h -6.485 z",
    style: {
      fill: "#ffde00",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path893"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g895",
    transform: "translate(1182.4659,364.9362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 8.06,41.511 C 8.516,43.835 9.809,45 11.945,45 h 0.132 l 1.418,7.327 H 13.389 C 6.284,52.327 2.031,48.719 0.63,41.511 L -7.43,0 Z",
    style: {
      fill: "#ffde00",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path897"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g899",
    transform: "translate(1199.4525,364.0961)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C 1.191,0 2.346,0.358 3.465,1.079 L 2.258,-5.17 c -0.456,-2.329 -1.759,-3.494 -3.912,-3.494 -2.17,0 -3.029,1.165 -2.573,3.494 l 0.367,1.862 h -7.43 l -0.367,-1.862 c -0.227,-1.193 -0.341,-2.276 -0.341,-3.255 0,-5.041 2.975,-7.571 8.926,-7.59 7.105,0 11.359,3.613 12.76,10.845 l 9.241,47.521 c 0.227,1.188 0.341,2.272 0.341,3.255 0,5.041 -2.976,7.562 -8.926,7.562 -7.106,0 -11.359,-3.609 -12.76,-10.817 L -8.533,10.845 C -9.951,3.613 -7.106,0 0,0 M -1.103,10.845 5.014,42.351 C 5.47,44.675 6.764,45.84 8.9,45.84 h 0.053 c 2.152,-0.014 3.002,-1.179 2.546,-3.489 L 5.356,10.793 C 4.9,8.497 3.597,7.351 1.444,7.351 c -2.153,0 -3.003,1.165 -2.547,3.494",
    style: {
      fill: "#ffde00",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path901"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g903",
    transform: "translate(1235.4204,392.7659)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C -1.26,1.103 -3.072,1.656 -5.434,1.656 -10.878,1.637 -14.299,-1.976 -15.7,-9.189 l -1.68,-8.635 c -0.227,-1.194 -0.341,-2.277 -0.341,-3.256 0,-5.041 2.976,-7.571 8.926,-7.59 7.105,0 11.359,3.613 12.76,10.846 l 6.117,31.505 c 0.227,1.189 0.341,2.272 0.341,3.255 0,5.041 -2.967,7.562 -8.9,7.562 -7.124,0 -11.385,-3.609 -12.785,-10.817 l -1.34,-6.931 h 7.43 l 1.339,6.931 c 0.456,2.31 1.759,3.475 3.912,3.489 h 0.053 c 2.136,0 2.976,-1.164 2.52,-3.489 z m -1.785,-9.16 -1.68,-8.664 c -0.456,-2.33 -1.759,-3.495 -3.912,-3.495 -2.17,0 -3.029,1.165 -2.573,3.495 l 1.68,8.635 c 0.456,2.329 1.769,3.494 3.938,3.494 2.136,0 2.984,-1.155 2.547,-3.465",
    style: {
      fill: "#ffde00",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path905"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g907",
    transform: "translate(1250.6484,364.9362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 8.06,41.511 C 8.516,43.835 9.809,45 11.945,45 h 0.053 c 1.979,-0.014 2.85,-1.007 2.626,-2.964 L 6.459,0 h 7.456 L 22.08,42.036 C 22.619,44.012 23.875,45 25.832,45 h 0.052 c 2.153,-0.014 3.003,-1.179 2.55,-3.489 L 20.371,0 h 7.432 l 8.058,41.511 c 0.229,1.188 0.344,2.272 0.344,3.255 0,5.041 -2.979,7.561 -8.927,7.561 -2.907,0 -5.332,-0.606 -7.275,-1.814 -1.503,1.208 -3.709,1.814 -6.614,1.814 C 6.284,52.327 2.031,48.719 0.63,41.511 L -7.43,0 Z",
    style: {
      fill: "#ffde00",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path909"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g911",
    transform: "translate(1305.0739,417.2636)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -7.108,0 -11.361,-3.609 -12.76,-10.816 l -6.143,-31.506 c -0.229,-1.193 -0.344,-2.287 -0.344,-3.284 0,-5.041 2.969,-7.562 8.903,-7.562 7.122,0.02 11.385,3.633 12.783,10.846 l 6.143,31.506 c 0.23,1.188 0.344,2.271 0.344,3.255 C 8.926,-2.52 5.948,0 0,0 m 1.155,-10.816 -6.143,-31.506 c -0.459,-2.33 -1.772,-3.494 -3.939,-3.494 -2.152,0 -3.002,1.164 -2.549,3.494 l 6.144,31.506 c 0.439,2.324 1.723,3.489 3.862,3.489 h 0.052 c 2.153,-0.015 3.007,-1.179 2.573,-3.489",
    style: {
      fill: "#ffde00",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path913"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g915",
    transform: "translate(1052.8948,339.2925)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h -7.43 l -1.578,-8.127 h 7.43 z",
    style: {
      fill: "#ffde00",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path917"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g919",
    transform: "translate(1043.3416,328.3579)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 -8.084,-41.631 h 7.43 L 7.43,0 Z",
    style: {
      fill: "#ffde00",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path921"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g923"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g925",
    clipPath: "url(#clipPath929)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g931",
    transform: "translate(1070.6215,345.9862)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -7.105,0 -11.358,-3.609 -12.759,-10.817 l -9.399,-48.442 h 7.43 l 9.399,48.442 c 0.455,2.325 1.749,3.49 3.885,3.49 h 0.052 c 2.154,-0.015 3.003,-1.18 2.547,-3.49 l -9.398,-48.442 h 7.43 l 9.398,48.442 c 0.227,1.189 0.342,2.272 0.342,3.255 C 8.927,-2.52 5.95,0 0,0",
    style: {
      fill: "#ffde00",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path933"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g935",
    transform: "translate(1118.7462,332.1755)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0,4.568 -2.163,6.86 -6.485,6.879 -2.362,0 -4.384,-0.554 -6.065,-1.657 l 5.688,29.103 h -7.43 l -13.59,-69.768 c -0.227,-1.194 -0.341,-2.277 -0.341,-3.256 0,-5.041 2.976,-7.571 8.926,-7.59 7.106,0 11.359,3.613 12.76,10.846 L -0.42,-3.967 C -0.141,-2.497 0,-1.174 0,0 m -7.85,-3.967 -6.117,-31.476 c -0.456,-2.33 -1.76,-3.495 -3.912,-3.495 -2.17,0 -3.029,1.165 -2.573,3.495 l 6.117,31.505 c 0.473,2.31 1.776,3.465 3.912,3.465 2.169,0 3.029,-1.164 2.573,-3.494",
    style: {
      fill: "#ffde00",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path937"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g939",
    transform: "translate(1133.475,338.2382)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h -7.43 l -1.373,-7.072 h 7.429 z",
    style: {
      fill: "#ffde00",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path941"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g943",
    transform: "translate(1124.1265,328.3579)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 -8.084,-41.631 h 7.43 L 7.43,0 Z",
    style: {
      fill: "#ffde00",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path945"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g947"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g949",
    clipPath: "url(#clipPath953)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g955",
    transform: "translate(1145.1056,296.7321)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -0.456,-2.329 -1.768,-3.494 -3.938,-3.494 -2.153,0 -3.003,1.165 -2.547,3.494 l 6.144,31.506 c 0.436,2.324 1.723,3.489 3.859,3.489 H 3.571 C 5.724,34.98 6.58,33.816 6.143,31.506 L 4.778,24.574 h 7.43 l 1.365,6.932 c 0.227,1.188 0.342,2.271 0.342,3.255 0,5.041 -2.976,7.561 -8.927,7.561 -7.105,0 -11.358,-3.609 -12.759,-10.816 L -13.915,0 c -0.227,-1.193 -0.341,-2.287 -0.341,-3.284 0,-5.041 2.967,-7.561 8.9,-7.561 C 1.769,-10.826 6.029,-7.213 7.43,0 l 1.365,6.931 h -7.43 z",
    style: {
      fill: "#ffde00",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path957"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g959",
    transform: "translate(1173.8018,338.2382)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h -7.43 l -1.373,-7.072 h 7.429 z",
    style: {
      fill: "#ffde00",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path961"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g963",
    transform: "translate(1164.4531,328.3579)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 -8.084,-41.631 h 7.43 L 7.43,0 Z",
    style: {
      fill: "#ffde00",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path965"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g967"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g969",
    clipPath: "url(#clipPath973)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g975",
    transform: "translate(1185.4324,296.7321)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -0.456,-2.329 -1.768,-3.494 -3.938,-3.494 -2.153,0 -3.003,1.165 -2.547,3.494 l 6.144,31.506 c 0.436,2.324 1.723,3.489 3.859,3.489 H 3.571 C 5.724,34.98 6.58,33.816 6.143,31.506 L 4.778,24.574 h 7.43 l 1.365,6.932 c 0.227,1.188 0.342,2.271 0.342,3.255 0,5.041 -2.976,7.561 -8.927,7.561 -7.105,0 -11.358,-3.609 -12.759,-10.816 L -13.915,0 c -0.227,-1.193 -0.341,-2.287 -0.341,-3.284 0,-5.041 2.966,-7.561 8.9,-7.561 C 1.769,-10.826 6.029,-7.213 7.43,0 l 1.365,6.931 h -7.43 z",
    style: {
      fill: "#ffde00",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path977"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g979",
    transform: "translate(1212.0702,365.0705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 -15.375,-78.344 h 7.43 L 7.43,0 Z",
    style: {
      fill: "#ffde00",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path981"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g983"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g985",
    clipPath: "url(#clipPath989)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g991",
    transform: "translate(1230.7474,339.0542)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -7.105,0 -11.358,-3.609 -12.76,-10.816 l -6.143,-31.506 c -0.227,-1.193 -0.341,-2.287 -0.341,-3.284 0,-5.041 2.966,-7.562 8.9,-7.562 7.124,0.02 11.385,3.633 12.786,10.846 l 1.365,6.931 h -7.43 l -1.365,-6.931 c -0.456,-2.33 -1.769,-3.494 -3.939,-3.494 -2.152,0 -3.002,1.164 -2.546,3.494 l 2.363,12.077 H 4.805 l 3.78,19.429 c 0.227,1.188 0.342,2.271 0.342,3.255 C 8.927,-2.52 5.95,0 0,0 m 1.155,-10.816 -2.363,-12.078 h -6.484 l 2.363,12.078 c 0.436,2.324 1.723,3.489 3.859,3.489 h 0.052 c 2.153,-0.015 3.01,-1.179 2.573,-3.489",
    style: {
      fill: "#ffde00",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path993"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g995",
    transform: "translate(1263.1716,338.2382)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h -5.75 l 4.712,26.832 h -7.43 L -13.18,0 h -5.329 l -1.418,-7.323 h 5.33 l -8.586,-44.188 h 7.43 l 8.586,44.188 h 5.749 z",
    style: {
      fill: "#ffde00",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path997"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g999",
    transform: "translate(1282.729,338.2382)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h -5.748 l 4.713,26.832 H -8.468 L -13.18,0 h -5.327 l -1.418,-7.323 h 5.327 l -8.582,-44.188 h 7.427 l 8.588,44.188 h 5.747 z",
    style: {
      fill: "#ffde00",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path1001"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g1011",
    transform: "translate(1296.9874,339.0542)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -7.127,0 -11.385,-3.609 -12.788,-10.816 l -1.337,-6.932 h 7.427 l 1.342,6.932 c 0.453,2.31 1.757,3.474 3.91,3.489 h 0.052 c 2.139,0 2.979,-1.165 2.52,-3.489 l -2.649,-13.682 c -1.26,1.103 -3.074,1.657 -5.437,1.657 -5.442,-0.019 -8.864,-3.633 -10.263,-10.846 l -1.68,-8.635 c -0.229,-1.193 -0.344,-2.277 -0.344,-3.256 0,-5.04 2.979,-7.57 8.926,-7.59 7.108,0 11.362,3.614 12.76,10.846 l 6.12,31.506 c 0.224,1.188 0.339,2.271 0.339,3.255 C 8.898,-2.52 5.933,0 0,0 m -3.308,-33.658 -1.68,-8.664 c -0.459,-2.33 -1.762,-3.494 -3.915,-3.494 -2.167,0 -3.026,1.164 -2.573,3.494 l 1.681,8.635 c 0.458,2.33 1.771,3.494 3.938,3.494 2.138,0 2.983,-1.155 2.549,-3.465",
    style: {
      fill: "#ffde00",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path1013"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1015",
    transform: "translate(1142.5061,416.4477)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h -11.446 c -1.02,-5.254 -2.041,-10.507 -3.061,-15.76 l -6.408,-35.751 h 10.44 c 6.914,0.019 11.069,3.623 12.471,10.816 l 1.523,7.772 c 0.646,3.379 -0.246,5.766 -2.679,7.17 2.977,1.398 4.796,3.79 5.461,7.165 l 1.497,7.747 c 0.246,1.26 0.368,2.415 0.368,3.466 C 8.166,-2.478 5.444,-0.015 0,0 m -3.911,-32.923 -1.523,-7.772 c -0.456,-2.324 -1.759,-3.489 -3.912,-3.489 h -3.256 l 2.862,14.755 h 2.337 c 1.033,0 1.732,-0.081 2.1,-0.239 1.244,-0.525 1.707,-1.608 1.392,-3.255 m 4.279,22.082 -1.497,-7.747 c -0.331,-1.643 -1.224,-2.74 -2.678,-3.28 -0.403,-0.143 -1.119,-0.21 -2.152,-0.21 h -2.337 l 2.862,14.755 h 3.255 c 2.153,0 3.003,-1.174 2.547,-3.518",
    style: {
      fill: "#ffde00",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path1017"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d7d9102cde645db8811258546a046263.svg";
export { ForwardRef as ReactComponent };